// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/poi_detail.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { PoiDetailService } from "./poi_detail_pb";

/**
 * GetPoi returns one POI by id.
 *
 * @generated from rpc travplaces.v1.PoiDetailService.GetPoi
 */
export const getPoi = PoiDetailService.method.getPoi;

/**
 * GetPoiDetails returns one POI plus enrichment (photos, phone, website).
 *
 * @generated from rpc travplaces.v1.PoiDetailService.GetPoiDetails
 */
export const getPoiDetails = PoiDetailService.method.getPoiDetails;
